import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";
import { useTranslation } from "react-i18next";

const reveal = {
  hidden: { opacity: 0, y: 32 },
  visible: (i: number) => ({
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.7,
      delay: i * 0.12,
      ease: [0.16, 1, 0.3, 1] as [number, number, number, number],
    },
  }),
};

const NotFound = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-[#fffefd] flex flex-col relative overflow-hidden">
      {/* Content — centered */}
      <motion.div
        initial="hidden"
        animate="visible"
        className="flex-1 flex flex-col items-center justify-center px-6 py-24 md:py-32 text-center"
      >
        {/* 404 number above the title */}
        <motion.span
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1.2, ease: [0.16, 1, 0.3, 1] }}
          className="text-[4rem] md:text-[6rem] font-gnarly-semibold text-neutral-900/[0.06] leading-none select-none mb-2 md:mb-3"
        >
          404
        </motion.span>
        <motion.h1
          custom={0}
          variants={reveal}
          className="text-4xl md:text-[4.25rem] font-gnarly-semibold leading-[1.05] tracking-tight text-neutral-900 mb-4 md:mb-6"
        >
          {t("page_not_found_title", "This page doesn't exist")}
        </motion.h1>

        <motion.p
          custom={1}
          variants={reveal}
          className="text-base md:text-xl font-gnarly-regular leading-relaxed text-neutral-500 max-w-md mb-10 md:mb-14"
        >
          {t(
            "page_not_found_body",
            "The page you're looking for may have been moved or no longer exists.",
          )}
        </motion.p>

        <motion.div custom={2} variants={reveal}>
          <Link
            to="/"
            className="group inline-flex items-center gap-3 bg-neutral-900 text-white font-gnarly-semibold text-lg px-8 py-4 rounded-full transition-all duration-300 hover:bg-neutral-800 hover:gap-4"
          >
            <ArrowLeft className="w-5 h-5 transition-transform duration-300 group-hover:-translate-x-0.5" />
            {t("back_to_home", "Back to home")}
          </Link>
        </motion.div>
      </motion.div>
    </div>
  );
};

export default NotFound;
